import React from 'react';
import styled from 'styled-components';

const PageWrapper = styled.div`
  background: linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)),
              url('https://images.unsplash.com/photo-1563589173312-476d8c36b242?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
  min-height: 100vh;
`;

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 7rem 2rem;
  flex: 1;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.8rem;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: #666;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 4rem;
`;

const InfoSection = styled.div`
  background: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #333;
    font-weight: 600;
  }

  p {
    color: #666;
    line-height: 1.8;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
`;

const Map = styled.div`
  height: 400px;
  border-radius: 10px;
  margin-top: 2rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const Input = styled.input`
  padding: 1rem;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  background: rgba(255, 255, 255, 0.9);

  &:focus {
    outline: none;
    border-color: #ff6b6b;
  }
`;

const TextArea = styled.textarea`
  padding: 1rem;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 1rem;
  min-height: 150px;
  transition: border-color 0.3s ease;
  background: rgba(255, 255, 255, 0.9);

  &:focus {
    outline: none;
    border-color: #ff6b6b;
  }
`;

const Button = styled.button`
  background-color: #ff6b6b;
  color: white;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(255, 107, 107, 0.2);

  &:hover {
    background-color: #ff5252;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  }
`;

function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
  };

  return (
    <PageWrapper>
      <ContactContainer>
        <Title>Contact Us</Title>
        <Subtitle>We'd love to hear from you!</Subtitle>
        <ContentWrapper>
          <InfoSection>
            <h3>Visit Our Store</h3>
            <p>120 Newburyport Turnpike</p>
            <p>Rowley, MA 01969</p>
            <p>Phone: (978) 432-1267</p>
            <p>Email: info@essexicecream.com</p>
            
            <h3>Hours</h3>
            <p>Monday - Thursday: 11am - 9pm</p>
            <p>Friday - Saturday: 11am - 10pm</p>
            <p>Sunday: 12pm - 9pm</p>
            
            <Map>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.8147670793837!2d-70.87843372346065!3d42.7141645711975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e2e9b5d90e9bed%3A0x7f075f59e7c0cefe!2s120%20Newburyport%20Turnpike%2C%20Rowley%2C%20MA%2001969!5e0!3m2!1sen!2sus!4v1707235405"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Store Location"
              />
            </Map>
          </InfoSection>

          <InfoSection>
            <h3>Send Us a Message</h3>
            <ContactForm onSubmit={handleSubmit}>
              <Input type="text" placeholder="Name" required />
              <Input type="email" placeholder="Email" required />
              <Input type="text" placeholder="Subject" required />
              <TextArea placeholder="Your message" required />
              <Button type="submit">Send Message</Button>
            </ContactForm>
          </InfoSection>
        </ContentWrapper>
      </ContactContainer>
    </PageWrapper>
  );
}

export default Contact;
